import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

// Reads and clears the walk-in customer submissions that customers pre-filled
// themselves via the public customer frontend. Submissions are scoped to the
// branch selected in the create-booking modal.
const useWalkInSubmissions = () => {
  const { isLoading, error, setError, sendRequest } = useHttp();
  const authCtx = useContext(AuthContext);

  const getPendingWalkInSubmissions = async branchId => {
    try {
      const response = await sendRequest({
        url: `/api/v1/walkInCustomerSubmission/pending/${branchId}`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      setError(err);
      throw err;
    }
  };

  const deleteWalkInSubmission = async id => {
    try {
      const response = await sendRequest({
        url: `/api/v1/walkInCustomerSubmission/${id}`,
        method: 'DELETE',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      setError(err);
      throw err;
    }
  };

  return { getPendingWalkInSubmissions, deleteWalkInSubmission, isLoading, error, setError };
};

export default useWalkInSubmissions;
